<template>
  <v-btn fab x-small to="/cart">
    <v-icon>mdi-cart-outline</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "XsCartButton"
};
</script>
